import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{attrs:{"top":"","color":"error"},model:{value:(_vm.showError),callback:function ($$v) {_vm.showError=$$v},expression:"showError"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.errorMessage)}}),_c(VBtn,{attrs:{"color":"white","text":""},on:{"click":_vm.removeErrors}},[_vm._v("\n    Close\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }